<template>
    <section class="mobile-trasaction-details-section wallet-trans-wrapper">
        <!-- <div class="payment-history payment-rejected">
            <div class="payment-iocn payment-approved">
                <img src="@/assets/images/payment-rejected.svg" alt="payment-rejected" loading="lazy" />
            </div>
            <div class="request_title">
                <p class="para-three"></p>
                <p>Deposit Request Cancelled</p>
            </div>
            <div class="trans-back-sec">
                <a href="Javascript:void(0);">
                    <span @click.prevent="$router.back()">
                        <i class="fa-solid fa-arrow-left"></i>
                    </span>
                </a>
            </div>
        </div> -->

        <div class="payment-history" :class="['reject_in_process','reject_completed','expired','cancelled'].includes(transactionDetails.status) ? 'payment-rejected' : (transactionDetails.status == 'hold' ? 'payment-pending' : '')" >
            <div class="payment-iocn payment-approved">
                  <img v-if="['approve_completed','approve_in_process'].includes(transactionDetails.status)" src="@/assets/images/payment-approved.svg" alt="payment-approved" loading="lazy">
                  <img v-if="['reject_in_process','reject_completed','expired', 'cancelled'].includes(transactionDetails.status)" src="@/assets/images/payment-rejected.svg" alt="payment-rejected" loading="lazy">
                  <img v-if="['hold'].includes(transactionDetails.status)" src="@/assets/images/hold_icon.svg" alt="payment-processing" loading="lazy">
            </div>
            <div class="request_title">
                  <p class="para-three">{{ transactionDetails?.user_name }}</p>
                  <p>{{ transactionDetails?.type?.includes('deposit') ? 'Deposit' : 'Withdrawal'}} Request {{transactionDetails?.status.includes('approve') ? 'Approved' : (transactionDetails?.status.includes('reject') ? 'Rejected' : (transactionDetails?.status.includes('cancelled') ? 'Cancelled' : 'In Process'))}}</p>
            </div>
            <!-- <div class="trans-back-sec">
                <a href="Javascript:void(0);">
                    <span @click.prevent="$router.back()">
                        <i class="fa-solid fa-arrow-left"></i>
                    </span>
                </a>
            </div> -->
         </div>

        <div class="trasaction-dtails-container" v-if="transactionDetails">
            <!-- <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('request-ids','Request Id')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{transactionDetails.transaction_id ?? '-'}}</div>
            </div> -->
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('request-date','Request Date')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr"><span>{{ transactionDetails?.created_at ? $dateTime.getLocalDate(transactionDetails?.created_at, 'DD/MM/YYYY hh:mm:ss') : '-'}}</span></div>
            </div>
            <div v-if="transactionDetails?.status != 'hold'" class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('action-date','Action Date')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr"><span>{{ transactionDetails?.action_at ? $dateTime.getLocalDate(transactionDetails.action_at, 'DD/MM/YYYY hh:mm:ss') : '-' }}</span></div>
            </div>
            <div v-else class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('hold-at','Hold At')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr"><span>{{ transactionDetails?.hold_at ? $dateTime.getLocalDate(transactionDetails.hold_at, 'DD/MM/YYYY hh:mm:ss') : '-' }}</span></div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('requested-amount','Requested Amount')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{ transactionDetails.amount }}</div>
            </div>
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('reference-number','Reference Number')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{ transactionDetails.transaction_id }}</div>
            </div>
            <div v-if="['approve_completed','approve_in_process'].includes(transactionDetails.status)" class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('approved-amount','Approved Amount')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{ transactionDetails.approved_amount }}</div>
            </div>
            <!-- <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('type','Type')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{ toTitleCaseWithSpaces(transactionDetails.type) }}</div>
            </div> -->
            <!-- <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('status','Status')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">{{ getTransactionStatus(transactionDetails.status).label }}</div>
            </div> -->
            <div class="detailedTransaction-container-info">
                <div class="detailedTransaction-container-info-title">{{$t('remarks','Remarks')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">
                    <div>{{ transactionDetails.remark ? transactionDetails.remark : '-'  }}</div>
                </div>
            </div>
            <div class="detailedTransaction-container-info" v-if="transactionDetails.transaction_image_url">
                <div class="detailedTransaction-container-info-title">{{$t('transaction-images','Transaction Images')}}</div>
                <div class="dots-div">:</div>
                <div class="detailedTransaction-container-info-descr">
                    <a class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#transactionModal">{{$t('view-details','View Details')}}</a>
                </div>
            </div>
        </div>
        <div class="detailedTransaction-container" v-else>
            <p>{{$t('no-record-found','No record found')}}</p>
        </div>
    </section>
    <!-- transaction details modal -->
    <div class="modal fade history-filter-modal transaction_detail_modal" id="transactionModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                <div class="thm-heading">
                    <p class="para-three">{{ $t('details','Details') }}</p>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                <div v-if="transactionImageLists?.length">
                    <div class="qrPreview-image">
                        <template v-for="(image, index) in transactionImageLists" :key="index">
                            <a :href="image" download target="_blank" class="transactionImage-item">
                                <img :src="image" alt="transactionImage" height="100%" width="100px" />
                            </a>
                        </template> 
                    </div>
                </div>
                <div v-else>
                    <p class="text-center" style="color: #000;">{{ $t('no-record-found','No Record found') }}</p>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTransactionStatus, createComputedPropertiesForTransactionDetails } from '@template/utils';
export default {
    name: 'TransactionDetails',
    data(){
            return{
                transactionId: null
            }
    },
    computed:{
        ...mapGetters(['transactionDetails']),
        ...{}
    },
    beforeCreate() {
        let {transactionImageLists} = createComputedPropertiesForTransactionDetails(this);
        this.$helper.applySharedComputed(this, {transactionImageLists})
    },
    mounted(){
        this.transactionId = this.$route?.params?.id
    },
    methods:{
        getTransactionStatus,
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        }
    }
}
</script>
<style scoped>

.thm-heading .para-three{
   color: white !important
}
.payment-pending{
    background-color: #F4D821 !important;
}
</style>